import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionShareAndroid16 } from '@cian/ui-kit-design-tokens/icons';

interface IShareButtonProps {
  onClick(): void;
}

export const ShareButton = React.forwardRef(function ShareButton(
  { onClick }: IShareButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>,
) {
  return (
    <Button
      data-testid={'ShareButton'}
      theme={'fill_secondary'}
      size={'XS'}
      onClick={onClick}
      ref={ref}
      beforeIcon={<IconActionShareAndroid16 color={'icon-main-default'} />}
    ></Button>
  );
});
